import axios from "axios";

import type { AnalyticsTrackEvent } from "@virtual-brain-lib/types";

import env from "../environments";

export async function track<S extends string>(eventName: AnalyticsTrackEvent<S>, data?: TrackData) {
	try {
		const name = eventName.join("_");

		await axios.post(`${env.apiUrl}/obiwan/kenobi`, {
			eventName: name,
			data,
		});
	} catch (error) {
		console.error("Failed to track event:", error);
	}
}

type TrackData = Record<string, boolean | string> | undefined;
